var processInclude = require('base/util');
const getBaseConfig = require('./common/getBaseConfig');
var BASE_CONFIG = getBaseConfig();

processInclude(require('./geolocation/redirectByGeolocation'));

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/detailImageSlider'));
    processInclude(require('./product/productDetailStyles'));
    processInclude(require('./product/productDetailVideo'));
    if (BASE_CONFIG.isWishlistEnabled) {
        processInclude(require('./product/wishlist'));
    }
    processInclude(require('./product/imageZoom'));
    processInclude(require('./product/bundleDetails'));
});
